import { setUser } from '@/utils/metrics';
import type { AuthState, OktaAuth } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';
import * as Sentry from '@sentry/react';
import { createContext, useContext } from 'react';

type AuthContextType = {
  authState: AuthState | null;
  oktaAuth: OktaAuth | null;
};

// oxlint-disable-next-line react-refresh/only-export-components
export const AuthContext = createContext<AuthContextType>({ authState: null, oktaAuth: null });

export const AuthContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { authState, oktaAuth } = useOktaAuth();

  if (authState?.isAuthenticated && authState?.idToken?.claims.sub) {
    Sentry.setUser({
      email: authState?.idToken?.claims.email,
      id: authState?.idToken?.claims.sub,
      username: authState?.idToken?.claims.name,
    });
    setUser({
      id: authState?.idToken?.claims.sub,
    });
  }

  return <AuthContext.Provider value={{ authState, oktaAuth }}>{children}</AuthContext.Provider>;
};

// oxlint-disable-next-line react-refresh/only-export-components
export const useAuthContext = (): AuthContextType => useContext(AuthContext);
